<template>
</template>

<script>
import SalesShipmentsPrintDeliveryNoteHTML from '@/views/sales/shipments/SalesShipmentsPrintDeliveryNoteHTML'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'SalesShipmentsPrintDeliveryNote',
  mixins: [SalesShipmentsPrintDeliveryNoteHTML,printHtml],
  props: {
    shipment: {type:Object, required:false},
    shipments: {type:Array, required:false}
  },
  data() {
    return {
      company: null,
    }
  },
  async created() {
    this.$emit('done');
    const results = await this.$apiCall(`query SalesShipmentsPrintDeliveryNote {
                                            company {name,address,city,province,postalCode,email,phone,logoURL}
                                          }`,
                                        {});
    if (results.error)
      return;
    this.company = results.data.company;

    const lines = [];
    const logos = this.company.logoURL ? [] : null;
    const shipments = this.shipment ? [this.shipment] : this.shipments;
    let n = shipments.length - 1;
    for (const shipment of shipments) {
      lines.push(await this.printDeliveryNote(shipment.id));
      if (n--)
        lines.push(`<div class="page-break"/>`);
      if (logos)
        logos.push({id:shipment.id, src:this.company.logoURL});
    }
    this.printHtml(`Delivery note ${this.shipments?'':this.shipment.invoice?.number}`, lines.join(''), logos);
  },
  methods: {
    async printDeliveryNote(id) {
      const results = await this.$apiCall(`query SalesShipmentsPrintDeliveryNote($id:ID!) {
                                              shipment(id:$id) {
                                                id,date,invoice{number},po,shipVia,shipToAddress,billToAddress,memo,draft,customer{license}
                                                lines {
                                                  sku,description,quantity,units,precision,weight,lot
                                                  items {sku,description,quantity,units,precision,weight,lot}
                                                }
                                              }
                                            }`,
                                          {id});
      if (results.error)
        return;
      results.data.shipment.invoiceNumber = results.data.shipment.invoice?.number ?? '';
      results.data.shipment.customerLicense = results.data.shipment.customer.license ?? '';
      return this.print(this.company, results.data.shipment);
    }
/*
    async print(id) {
      const results = await this.$apiCall(`query SalesShipmentsPrintDeliveryNote($id:ID!) {
                                              shipment(id:$id) {
                                                date,invoice{number},po,shipVia,shipToAddress,billToAddress,memo,draft,customer{license}
                                                lines {
                                                  sku,description,quantity,units,precision,weight,lot
                                                  items {sku,description,quantity,units,precision,weight,lot}
                                                }
                                              }
                                            }`,
                                          {id});
      if (results.error)
        return;

      const shipment = results.data.shipment;
      const lines = [`
        <table class="delivery-note-print">
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <thead>
            ${!shipment.draft ? '' : `<tr><td colspan="20" class="draft">DRAFT</td></tr>`}
            <tr>
            <th rowspan="5" colspan="2"><img id="${id}" style="width:72px"/></th>
              <th style="padding-left:20px" rowspan="5" colspan="6">
                <strong>${this.company.name}</strong><br/>
                ${this.company.address || ''}<br/>
                ${this.company.city || ''} ${this.company.province || ''}  ${this.company.postalCode || ''}<br/>
                ${this.company.phone || ''}</br>
                ${this.company.email || ''}
              </th>
              <th style="color:#aaa;font-size:36px;font-weight:700;text-align:right;padding-bottom:20px" colspan="12">DELIVERY NOTE</th>
            </tr>
            <tr>
              <th colspan="4"/>
                ${shipment.invoice ? '<th colspan="4" class="header title">INVOICE #' : '<th colspan="4">'}</th>
              <th colspan="4" class="header title">DATE</th>
            </tr>
            <tr>
              <th colspan="4"/>
              ${shipment.invoice ? `<th colspan="4" class="header">${shipment.invoice.number}` : '<th colspan="4">'}</th>
              <th colspan="4" class="header">${this.$formatDate(shipment.date)}</th>
            </tr>
            <tr>
              <th colspan="4"/>
              <th colspan="4" class="header title">CUSTOMER PO</th>
              <th colspan="4" class="header title">SHIP VIA</th>
            </tr>
            <tr>
              <th colspan="4"/>
              <th colspan="4" class="header">${shipment.po}&nbsp;</th>
              <th colspan="4" class="header">${shipment.shipVia}</th>
            </tr>
            <tr>
              <th colspan="4"/>
              <th colspan="4">&nbsp;</th>
              <th colspan="4"></th>
            </tr>
            <tr style="margin-top:20px">
              <th colspan="8" class="header title">BILL TO</th>
              <th colspan="4" style="border-top:none"/>
              <th colspan="8" class="header title">SHIP TO</th>
            </tr>
            <tr>
              <th colspan="8" style="padding-top:10px;padding-bottom:20px">
                ${shipment.billToAddress.replace(/\n/gi,'<br/>')}
                ${shipment.customer.license && this.printCustomerLicense ? `<br/>License #${shipment.customer.license}` :  ''}
              </th>
              <th colspan="4"/>
              <th colspan="8" style="padding-top:10px;padding-bottom:20px">
                ${shipment.shipToAddress.replace(/\n/gi,'<br/>')}
              </th>
            </tr>
            <tr>
              <th colspan="4" class="header title">ITEM</th>
              <th colspan="12" class="header title">DESCRIPTION</th>
              <th colspan="4" class="header title">QTY</th>
            </tr>
          </thead>
          <tbody>`];
      shipment.lines.forEach(line => {
        if (line.items)
          line.items.forEach(bundleLine => {
            lines.push(`<tr>
                          <td colspan="4">${bundleLine.sku}</td>
                          <td colspan="12">${bundleLine.description}${this.printLotCodes && line.lot?`<br/>Lot ${line.lot}`:''}</td>
                          <td colspan="4" class="right">${this.$number(bundleLine.quantity, bundleLine.precision)} ${bundleLine.units}</td>
                        </tr>`);
          });
        else
          lines.push(`<tr>
                        <td colspan="4">${line.sku}</td>
                        <td colspan="12">${line.description}${this.printLotCodes && line.lot?`<br/>Lot ${line.lot}`:''}</td>
                        <td colspan="4" class="right">${this.$number(line.quantity, line.precision)} ${line.units}</td>
                      </tr>`);
      });
      lines.push(`<tr>
                    <td colspan="20" style="padding-top:100px;padding-bottom:100px">RECEIVED IN GOOD CONDITION BY</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td colspan="6" style="border-top:1px solid #888">Signature</td>
                    <td>&nbsp;</td>
                    <td colspan="7" style="border-top:1px solid #888">Name</td>
                    <td>&nbsp;</td>
                    <td colspan="4" style="border-top:1px solid #888">Date</td>
                  </tr>
                  </tbody>
                </table>`);
      return lines;
    }
    */
  }
}
</script>